import TableCellLink from "ds/components/Table/Row/CellLink";

import EnvironmentTableCell from "../Cell";
import { EnvironmentContextCellProps } from "./types";

const ContextNameCell = ({ item, ...cellProps }: EnvironmentContextCellProps) => {
  return (
    <EnvironmentTableCell {...cellProps} role="rowheader">
      <TableCellLink href={`/context/${item.contextId}`}>{item.contextName}</TableCellLink>
    </EnvironmentTableCell>
  );
};

export default ContextNameCell;
